// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"af0c2ecff73217ea","6233":"b385fe521bafef34","8559":"726eb804d4057c2a","9141":"fa42b60521dc7ed8"}[chunkId] + ".css";
};